import React from 'react'
import { hashHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import { syncHistoryWithStore } from 'react-router-redux'

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired
  }

  handleRouteUpdate() {
    const { action } = this.state.location
    if (action && (action === 'PUSH' || action === 'REPLACE')) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const history = syncHistoryWithStore(hashHistory, this.props.store)

    return (
      <Provider store={this.props.store}>
        <Router
          onUpdate={this.handleRouteUpdate}
          history={history}
          children={this.props.routes}
        />
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js